import React from "react";
import classNames from "classnames/bind";

import { Button } from "../Button";

import styles from "./ScreenMiratorg.module.css";

const cx = classNames.bind(styles);

type Props = {
  title: React.ReactNode;
  isLoading?: boolean;
  onSubmit?: (event: React.FormEvent<HTMLFormElement>) => void;
  miratorgData: {
    additional_text: string;
    button_lable: string;
    button_url?: string;
  };
  showDownloadButton?: boolean;
  showEmailButton?: boolean;
  downloadPdfHandler?: () => void
};

export const ScreenMiratorg: React.FC<Props> = (props) => {
  const content = (
    <div className={cx("inner")}>
      <header className={cx("header")}>
        <h1 className={cx("title")}>{props.title}</h1>
        {props.showDownloadButton &&
            <Button
                color="cerulean"
                block
                size="medium"
                rounded
                isLoading={props.isLoading}
                type="button"
                onClick={props.downloadPdfHandler}
            >
              Скачать отчет
            </Button>
        }
        {props.showEmailButton &&
            <Button
                color="cerulean"
                block
                size="medium"
                rounded
                isLoading={props.isLoading}
                type="submit"
            >
              Полный отчет на почту
            </Button>
        }
      </header>
      <div className={cx("content")}>
        <p
          className={cx("text")}
          dangerouslySetInnerHTML={{
            __html: props.miratorgData.additional_text
          }}
        ></p>
        <a href={props?.miratorgData?.button_url} target="_blank" rel="noreferrer">
          {props?.miratorgData?.button_lable}
        </a>
      </div>
    </div>
  );

  if (props.onSubmit) {
    return (
      <form className={cx("screen")} id={"screen"} onSubmit={props.onSubmit}>
        {content}
      </form>
    );
  }

  return (
    <div className={cx("screen")} id={"screen"}>
      {content}
    </div>
  );
};
